import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b5fd3d2c")

_pushScopeId("data-v-b5fd3d2c")
const _hoisted_1 = { class: "banner-item-area" }
const _hoisted_2 = { class: "banner-item-image-area" }
const _hoisted_3 = {
  key: 1,
  class: "banner-item-no-image",
  src: _imports_0
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "banner-item",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.imageUrl)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "banner-item-icon",
              src: _ctx.imageUrl,
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onError(...args)))
            }, null, 40, ["src"]))
          : (_openBlock(), _createBlock("img", _hoisted_3))
      ])
    ])
  ]))
})